export default __webpack_public_path__ + "static/media/art-brw-2.49ab3993.png";